export default "__VITE_ASSET__zPk98bHR__"